import React from 'react';

const FlagFilledIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M12.825 6.825L15.8468 3.06313C16.1097 2.73591 15.8767 2.25 15.457 2.25H5.4L2.25 16.5H3.75L4.95 11.25H13.8818C14.2368 11.25 14.4787 10.8904 14.345 10.5616L12.825 6.825Z" fill="#FF5E3A" />
    </svg>
  );
};

export default FlagFilledIcon;